import md5 from 'js-md5';
import addinstance from './instance.js'
import geturl from './seturl'
//集团管理
export const companylist= params=> {return addinstance().get(geturl(`/company/index`),{params:params});}
export const createcompany= params => { return addinstance().post(geturl(`/company/create`), params) };
export const updatecompany= params => { return addinstance().post(geturl(`/company/update`), params) };
export const deletecompany= params => { return addinstance().post(geturl(`/company/delete`), params) };
//集团管理员
export const company_adminlist= params=> {return addinstance().get(geturl(`/company_admin/index`),{params:params});}
export const createcompany_admin= params => { 
    if(params.password){
        params.password=md5(params.password)
    }
    return addinstance().post(geturl(`/company_admin/create`), params) };
export const updatecompany_admin= params => {
    if(params.password){
        params.password=md5(params.password)
    }
    return addinstance().post(geturl(`/company_admin/update`), params) };
export const deletecompany_admin= params => { return addinstance().post(geturl(`/company_admin/delete`), params) };
export const company_rolelist= params=> {return addinstance().get(geturl(`/company_role/index`),{params:params})};
export const company_service_index= params=> {return addinstance().get(geturl(`/company/service_index`),{params:params})};
export const company_service_set= params => { return addinstance().post(geturl(`/company/service_set`), params) };
export const hotel_list= params=> {return addinstance().get(geturl(`/company/hotel_list`),{params:params})};













// WEBPACK FOOTER //
// ./src/api/companyapi.js